import { apiClient } from './client';

/**
 * Exam API client.
 *
 * Backend endpoints (admin):
 *   POST   /exams                   — create
 *   GET    /exams/admin?courseId    — list
 *   GET    /exams/admin/:id         — single
 *   PUT    /exams/:id               — update
 *   PATCH  /exams/:id/publish       — publish
 *   PATCH  /exams/:id/archive       — archive (= unpublish)
 *   DELETE /exams/:id               — delete
 */

export async function listCourseExams(courseId, params = {}) {
  const { data } = await apiClient.get('/exams/admin', {
    params: { courseId, limit: 100, ...params },
  });
  return data;
}

export async function getExam(examId) {
  const { data } = await apiClient.get(`/exams/admin/${examId}`);
  return data;
}

export async function listExamAttempts(examId, params = {}) {
  const { data } = await apiClient.get(`/exams/admin/${examId}/attempts`, {
    params: { limit: 50, ...params },
  });
  return data;
}

export async function gradeExamAttempt(attemptId, payload) {
  const { data } = await apiClient.patch(`/exams/attempts/${attemptId}/grade`, payload);
  return data;
}

export async function createExam(payload) {
  const { data } = await apiClient.post('/exams', payload);
  return data;
}

export async function updateExam(examId, payload) {
  const { data } = await apiClient.put(`/exams/${examId}`, payload);
  return data;
}

export async function publishExam(examId) {
  const { data } = await apiClient.patch(`/exams/${examId}/publish`);
  return data;
}

export async function archiveExam(examId) {
  const { data } = await apiClient.patch(`/exams/${examId}/archive`);
  return data;
}

export async function deleteExam(examId) {
  const { data } = await apiClient.delete(`/exams/${examId}`);
  return data;
}
